import { createContext } from 'react'

export const NewContractContext = createContext({
  currentContract: {},
  users: []
})
